import { combineReducers } from "redux";

// V1 Reducer
import { style } from "./style";
import { user } from "./user";
import { employee } from "./employee";
import { group } from "./group";
import { employer } from "./employer";
import { remark } from "./remark";
import { company } from "./company";
import { billing } from "./billing";
import { payroll } from "./payroll";
import { loyalty } from "./loyalty";
import { dashboard } from "./dashboard";
import { privilege } from "./privilege";

export const v1Reducer = combineReducers({
  style,
  user,
  employee,
  group,
  employer,
  remark,
  company,
  billing,
  payroll,
  loyalty,
  privilege,
  dashboard,
});
